import React from 'react'
import {Modal} from 'react-bootstrap'
import {FormattedMessage} from 'react-intl'
import {useNavigate} from 'react-router-dom'
import {PolicyFamilyTree, FamilyItem} from './PolicyFamilyTree'

interface Props {
  isOpen: boolean
  onClose: () => void
  items: FamilyItem[]
  household: FamilyItem[]
  currentPk: number
}

export const ModalPolicyFamily: React.FC<Props> = ({isOpen, onClose, items, household, currentPk}) => {
  const navigate = useNavigate()

  const handleNavigate = (pk: number) => {
    onClose()
    navigate(`/one-policy/${pk}`)
  }

  return (
    <Modal show={isOpen} onHide={onClose} size='xl'>
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage
            id='policies.detail.family.modalTitle'
            defaultMessage='Related Policies'
          />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {items.length > 1 && (
          <>
            <p className='fw-bold mb-1'>
              <FormattedMessage
                id='policies.detail.family.duplicationChain'
                defaultMessage='Duplication chain'
              />
              <span className='text-muted fw-normal ms-2' style={{fontSize: '0.85rem'}}>
                <FormattedMessage
                  id='policies.detail.family.countParen'
                  defaultMessage='({count, plural, one {# policy} other {# policies}})'
                  values={{count: items.length}}
                />
              </span>
            </p>
            <p className='text-muted mb-2' style={{fontSize: '0.8rem'}}>
              <FormattedMessage
                id='policies.detail.family.duplicationHint'
                defaultMessage='Policies linked by duplication. Click any to navigate.'
              />
            </p>
            <PolicyFamilyTree items={items} currentPk={currentPk} onNavigate={handleNavigate} />
          </>
        )}

        {household.length > 0 && (
          <>
            <hr className='my-4' />
            <p className='fw-bold mb-1'>
              <FormattedMessage
                id='policies.detail.family.household'
                defaultMessage='Household / Contact network'
              />
              <span className='text-muted fw-normal ms-2' style={{fontSize: '0.85rem'}}>
                <FormattedMessage
                  id='policies.detail.family.countParen'
                  defaultMessage='({count, plural, one {# policy} other {# policies}})'
                  values={{count: household.length}}
                />
              </span>
            </p>
            <p className='text-muted mb-2' style={{fontSize: '0.8rem'}}>
              <FormattedMessage
                id='policies.detail.family.householdHint'
                defaultMessage='Other policies sharing a contact with this client.'
              />
            </p>
            <PolicyFamilyTree
              items={household}
              currentPk={-1}
              onNavigate={handleNavigate}
            />
          </>
        )}
      </Modal.Body>
    </Modal>
  )
}
